import { Typography } from 'antd';
import { Loadable, PageHeader, TabButtons, TabItem } from 'components';
import { useTitle } from 'hooks';
import { permissionsMessages, rolesMessages, sidebarMenuMessages } from 'messages';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ROUTE } from 'routes/constants';

function PermissionLayout() {
  useTitle(sidebarMenuMessages.permissions);
  const location = useLocation();
  const navigate = useNavigate();

  const tabItems: TabItem[] = [
    {
      key: ROUTE.PERMISSIONS,
      label: permissionsMessages.listPermission
    },
    {
      key: ROUTE.ROLES,
      label: rolesMessages.listRolePermission
    }
  ];

  const handleClickTab = (tabKey: string) => {
    navigate(tabKey);
  };

  return (
    <div>
      <PageHeader className='flex items-center gap-1'>
        <Typography.Title className='text-header-label mb-0 font-bold'>
          {sidebarMenuMessages.permissions}
        </Typography.Title>
      </PageHeader>
      <div className='h-full rounded-xl bg-colorBgContainer'>
        <TabButtons
          className='min-h-[88px] items-center p-6'
          items={tabItems}
          onClick={(tabKey) => handleClickTab(tabKey as string)}
          activeKey={location.pathname}
        />
        <div className='max-h-[calc(100%-56px)]'>
          <Loadable>
            <Outlet />
          </Loadable>
        </div>
      </div>
    </div>
  );
}

export default PermissionLayout;
